// styles.js ใช้สำหรับ render PDF ในหน้า QuotationPreview.js
import { StyleSheet } from "@react-pdf/renderer";

export const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 7,
    fontFamily: "NotoSansThai",
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
    paddingBottom: 5,
    borderBottomWidth: 2,
    borderBottomColor: "#4A3F7D",
  },
  logoContainer: {
    width: "40%", // ขยายให้เหมาะสมกับการแบ่งครึ่งหน้า
  },
  logo: {
    width: 430, // ปรับขนาดโลโก้ให้พอดี
    height: 50,
  },
  headerContent: {
    width: "60%", // ให้ส่วนหัวขวาใหญ่ขึ้นเล็กน้อย
    textAlign: "right",
  },
  headerTitle: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#4A3F7D",
  },
  headerDetailsWrapper: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 10,
  },
  clientDetailsContainer: {
    width: "50%", // ครึ่งหนึ่งของหน้า
    flexDirection: "column",
    paddingRight: 5,
  },
  headerDetailsContainer: {
    width: "50%", // อีกครึ่งหนึ่งของหน้า
    flexDirection: "column",
    alignItems: "flex-start",
    paddingLeft: 5,
  },
  detailRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 3,
  },
  detailRowProjectDetails: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "50%",
  },
  label: {
    fontSize: 7,
    fontWeight: "bold",
    color: "#4A3F7D",
    width: "35%", // ลดขนาด label เพื่อให้ value มีพื้นที่มากขึ้น
    textAlign: "left",
  },
  value: {
    fontSize: 7,
    fontWeight: "normal",
    color: "#000000",
    width: "65%", // ขยายพื้นที่ของ value
    textAlign: "left",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    paddingLeft: 2,
  },
  projectDetailsContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderTopWidth: 1,
    borderColor: "#4A3F7D",
    paddingTop: 5,
    marginTop: 10,
  },
  projectDetail: {
    flex: 1,
    paddingHorizontal: 10,
  },
  projectLabel: {
    fontSize: 7,
    fontWeight: "bold",
    color: "#4A3F7D",
    textAlign: "left",
    width: "40%",
  },
  projectValue: {
    fontSize: 8,
    fontWeight: "normal",
    color: "#000000",
    textAlign: "left",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    width: "60%",
  },
  section: {
    marginBottom: 20,
  },
  itemsTable: {
    display: "table",
    width: "100%",
    borderWidth: 1,
    borderStyle: "solid",
    marginTop: 0,
    fontSize: 7,
  },
  itemsTableSpacial: {
    display: "table",
    width: "100%",
    borderWidth: 1,
    borderStyle: "solid",
    fontSize: 7,
    // height: "75%", // กินพื้นที่ 75% ของ A4
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1, // ✅ ให้ขอบด้านล่างเป็นเส้นเดียว
    borderBottomColor: "#000",
    borderBottomStyle: "solid",
    alignItems: "center",
  },
  // ✅ ใช้เฉพาะบรรทัดสุดท้าย ไม่ต้องให้ border ซ้ำ
  lastTableRow: {
    flexDirection: "row",
    borderBottomWidth: 0, // ❌ เอาเส้นออกจากบรรทัดสุดท้าย
    alignItems: "center",
  },
  tableColHeaderNo: {
    width: "8%", // ช่อง No. เล็กลง
    borderStyle: "solid",
    borderWidth: 1,
    textAlign: "center",
    padding: 3,
    fontWeight: "bold",
    backgroundColor: "#f0f0f0",
    fontSize: 7,
  },
  tableColHeaderDesc: {
    flexGrow: 1, // ขยายใหญ่เท่าที่จำเป็น
    flexShrink: 1,
    borderStyle: "solid",
    borderWidth: 1,
    textAlign: "left",
    padding: 3,
    fontWeight: "bold",
    backgroundColor: "#f0f0f0",
    fontSize: 7,
  },
  tableColHeader: {
    width: "16%", // ช่อง Units, Unit Price และ Amount เท่ากัน
    borderStyle: "solid",
    borderWidth: 1,
    textAlign: "center",
    padding: 3,
    fontWeight: "bold",
    backgroundColor: "#f0f0f0",
    fontSize: 7,
  },
  tableColNo: {
    width: "8%",
    textAlign: "center",
    paddingVertical: 3,
  },
  tableColDesc: {
    width: "40%",
    textAlign: "left",
    paddingVertical: 3,
  },
  tableColUnit: {
    width: "16%",
    textAlign: "center",
    paddingVertical: 3,
  },
  tableCol: {
    width: "16%",
    textAlign: "right",
    paddingRight: 4,
  },
  summaryContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 5,
    borderWidth: 1,
    borderStyle: "solid",
    fontSize: 7,
  },
  paymentDetails: {
    width: "50%",
    padding: 7,
    // backgroundColor: "#f8f8f8",
    borderRightWidth: 1,
    borderStyle: "solid",
    fontSize: 7,
  },
  summary: {
    width: "50%",
    padding: 8,
    fontSize: 7,
  },
  summaryRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottomWidth: 1,
    padding: 5,
    fontSize: 7,
  },
  summaryRowLast: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 5,
    fontSize: 7,
  },
  characterAmount: {
    textAlign: "left",
    fontWeight: "bold",
    marginTop: 10,
    borderTopWidth: 1,
    borderStyle: "solid",
    paddingTop: 5,
    fontSize: 8,
  },
  signatureSection: {
    marginTop: 60,
    flexDirection: "row",
    justifyContent: "space-between",
    fontSize: 8,
  },
  signatureBlock: {
    textAlign: "center",
    width: "30%",
    fontSize: 8,
  },
  remarkContainer: {
    marginTop: 10, // ✅ เพิ่มระยะห่างจากตาราง
    marginBottom: 5, // ✅ ปรับให้ห่างจาก Payment Details
    padding: 5,
    borderWidth: 1,
    borderStyle: "solid",
    fontSize: 7,
    // backgroundColor: "#f8f8f8",
  },
  remarkTitle: {
    fontSize: 7,
    fontWeight: "bold",
    marginBottom: 5,
    color: "#4A3F7D",
  },
  remarkText: {
    fontSize: 7,
    color: "#000",
  },
  borderLine: {
    borderTopWidth: 1,
    borderColor: "#000",
    marginVertical: 5,
  },
  pageNumber: {
    position: "absolute",
    bottom: 20,
    right: 30,
    fontSize: 10,
    fontWeight: "bold",
  },
  watermark: {
    position: "absolute",
    fontSize: 100,
    color: "rgba(255, 0, 0, 0.15)",
    transform: "rotate(-45deg)",
    top: "35%",
    left: "5%",
    textTransform: "uppercase",
  },
  textCondition: {
    marginTop: 5,
    fontSize: 5,
  },
});
